import React from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;
const highlightedRowStyle = {
  border: "2px solid #111827",
  borderRadius: "6px",
  padding: "8px",
  marginBottom: "10px",
  fontSize: "13px",
  fontWeight: 700,
  alignItems: "center",
};

const highlightedValueStyle = {
  fontWeight: 600,
};

const Print = ({ appointment }) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");
  const visitTicketNumber =
    appointment?.ticket_number_display ||
    appointment?.ticket_number ||
    appointment?.ticket?.ticket_number ||
    "-";
  const patientMrn =
    appointment?.patient_mrn_display ||
    appointment?.ticket?.patient_mrn_display ||
    appointment?.ticket?.patient?.mrn ||
    "-";
  const doctorDisplay =
    `${appointment?.doctor_name_display || ""} ${appointment?.doctor_lastname_display || ""}`.trim() ||
    appointment?.doctor_display ||
    "-";
  const ageDisplay =
    appointment?.patient_age_display ??
    appointment?.patient_age ??
    appointment?.age ??
    appointment?.patient?.age ??
    "-";
  const genderDisplay =
    appointment?.patient_gender_display ||
    appointment?.gender_display ||
    appointment?.patient_gender ||
    appointment?.gender ||
    appointment?.patient?.gender ||
    "-";

  return (
    <ThermalReceipt
      direction={direction}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      rows={[
        {
          label: `${t("print.visitTicketNumber", { defaultValue: "Visit Ticket Number" })}:`,
          value: visitTicketNumber,
          rowStyle: highlightedRowStyle,
          labelStyle: { fontWeight: 600 },
          valueStyle: highlightedValueStyle,
        },
        {
          label: `${t("print.mrn", { defaultValue: "MRN" })}:`,
          value: patientMrn,
        },
        { 
          label: `${t("print.doctor")}:`, 
          value: doctorDisplay,
          rowStyle: highlightedRowStyle,
          labelStyle: { fontWeight: 600 },
          valueStyle: highlightedValueStyle,
        },
          { label: `${t("print.inLine")}:`, value: appointment?.appointments_before ?? "-" },
        {
          label: `${t("print.patient")}:`,
          value: `${appointment?.patient_name_display || ""} ${appointment?.patient_lastname_display || ""}`.trim() || "-",
        },
        { 
          label: `${t("print.age")}:`, 
          value: ageDisplay,
        },
        { 
          label: `${t("print.gender")}:`, 
          value: genderDisplay,
        },
        { 
          label: `${t("print.date")}:`, 
          value: appointment?.dateOfVisit || "-" 
        },
      
        { label: `${t("print.fees")}:`, value: money(appointment?.fees) },
      ]}
      footerLines={[t("print.thankYou"), t("print.getWellSoon"), t("print.poweredBy")]}
    />
  );
};

export default Print;
